import { render } from "./UserTopBrands.vue?vue&type=template&id=61a420f6"
import script from "./UserTopBrands.vue?vue&type=script&lang=js"
export * from "./UserTopBrands.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UserTopBrands.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61a420f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61a420f6', __exports__)) {
    api.reload('61a420f6', __exports__)
  }
  
  module.hot.accept("./UserTopBrands.vue?vue&type=template&id=61a420f6", () => {
    api.rerender('61a420f6', render)
  })

}


export default __exports__